module.exports = "/_next/static/images/9ed45904d69516c9ebfde621be5ef3b8-hands-holding-cards-md@2x.jpg";